import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      HELP_US_IMPROVE_EXPERIENCE: "Hjelp oss med å forbedre din matopplevelse",
      DO_WE_HAVE_YOUR_APPROVAL:
        "Har vi ditt samtykke til å lagre og bruke hva du liker og misliker når vi anbefaler retter til deg?",
      SAVE_YOUR_ALLERGY_PREFERENCES:
        "Lagre dine allergipreferanser (om nødvendig)",
      AVOID_RECIEVING_FOOD_YOU_DISLIKE: "Unngå å motta mat du ikke liker",
      BETTER_RECOMMENDATIONS: "Bedre menyanbefalinger",
      I_APPROVE: "Jeg godtar",
      I_DONT_WANT_IT: "Jeg ønsker ikke en personlig matopplevelse",
    },
    se: {
      HELP_US_IMPROVE_EXPERIENCE: "Hjälp oss förbättra din matupplevelse",
      DO_WE_HAVE_YOUR_APPROVAL:
        "Har vi ditt godkännande att spara och använda vad du gillar och ogillar när vi rekommenderar rätter till dig?",
      SAVE_YOUR_ALLERGY_PREFERENCES: "Spara dina allergipreferenser (om några)",
      AVOID_RECIEVING_FOOD_YOU_DISLIKE: "Undvik att få rätter du inte gillar",
      BETTER_RECOMMENDATIONS: "Få bättre menyförslag",
      I_APPROVE: "Jag godkänner",
      I_DONT_WANT_IT: "Jag önskar inte en personlig matupplevelse",
    },
    dk: {
      HELP_US_IMPROVE_EXPERIENCE: "Hjælp os med at forbedre dine menuforslag",
      DO_WE_HAVE_YOUR_APPROVAL:
        "Vil du give os dit samtykke til at gemme oplysninger om, hvilken slags mad du kan lide og ikke kan lide, når vi anbefaler retter til dig?",
      SAVE_YOUR_ALLERGY_PREFERENCES: "Gem dine allergener (hvis nødvendigt)",
      AVOID_RECIEVING_FOOD_YOU_DISLIKE:
        "Undgå at modtage retter, du ikke kan lide",
      BETTER_RECOMMENDATIONS: "Få bedre menuforslag",
      I_APPROVE: "Godkend",
      I_DONT_WANT_IT: "Afvis",
    },
  } as const
)[language];
